
var ShapePageTransformModel = function() {

    this.rotation = 0;
    this.width = 0;
    this.height = 0;
    this.scale = 0;
    this.transform = '';

    return this;

};


_.extend( ShapePageTransformModel.prototype, {

    initializeValues: function( pageModel, scale ) {

        var pgDims = pageModel.getOriginalPageCanvasDimensions();

        this.rotation = pageModel.get('rotation') % 360;
        this.width = pgDims.w;
        this.height = pgDims.h;
        this.scale = scale;

        return this;

    },

    /* Update the values -- cb: typically function to transform the view --> was updatePageTransform */
    updateTransform: function( transformCb ) {

        var s = this.scale,
            r = this.rotation,
            pw = this.width,
            ph = this.height,
            cx = pw / 2,
            cy = ph / 2;

        this.transform = 's' + s + ',' + s + ',' + 0 + ',' + 0 +
            'r' + r + ',' + cx + ',' + cy;

        if ( r === 90 || r === 270 )
            this.transform += 'T' + ((ph - pw) * s / 2) + ',' + ((pw - ph) * s / 2);

        transformCb && transformCb.call( this, this.transform );

    },
    setTransform: function( transform ) {
        this.transform = transform;
    },
    getTransform: function( ) {
        return this.transform;
    },

    getRotation: function(  ) {
        return this.rotation;
    },
    setRotation: function( rotation ) {
        this.rotation = rotation;
    },
    getWidth: function() {
        return this.width;
    },
    setWidth: function( width ) {
        return this.width;
    },
    getHeight: function( ) {
        return this.height;
    },
    setHeight: function( height ) {
        this.height = height;
    },
    getScale: function() {
        return this.scale;
    },
    setScale: function( scale ) {
        this.scale = scale;
    },


    getCenter: function() {

        return {
            x: this.width / 2,
            y: this.height /2
        };

    }


});




module.exports = ShapePageTransformModel;






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/shapeTransformModel/shapePageTransformModel.js
 ** module id = 247
 ** module chunks = 0
 **/